module.exports = {
	"name": "Nagomi Sushi Downtown",
	"foodRecommendations": [
		{
			"text": "A boat of sushi is the best way to strengthen friendships and get some likes on instagram",
			"person": "Nick Kortman"
		}
	],
	"address": "241 E Liberty St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279703,
		"lng": -83.746649
	},
	"catImage": "greenstar.png",
	"totalCats": 1,
	"totalMisc": 0,
	"categories": {
		"location": 1,
		"fooddrink": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/nagomisushi.json
// module id = 929
// module chunks = 0